/* eslint-disable*/

import { Container, Typography, Box } from '@material-ui/core'; // eslint-disable-line
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { otherSelectedBrand } from 'feactures/brand/brandSlice';
import ProductAnalysisList from './ProductAnalysisList';
import { currentchannel } from 'feactures/channel/channelSlice';

const ProductAnalysisTable = (props) => {
  const { yokoziku, productList } = props;
  // const selectBrand = useSelector(otherSelectedBrand);

  return (
    <Container maxWidth={false} sx={{ mt: '-30px', mb: '30px' }}>
      <Box display="flex" alignItems="end" mb={'30px'}>
        <Typography fontSize="14px" fontWeight="bold">
          商品分析
        </Typography>
        <Typography fontSize="12px" sx={{ ml: '20px' }}>
          当月のデータがない商品は売上が表示できません。
        </Typography>
      </Box>

      <ProductAnalysisList
        productList={productList.length !== 0 ? productList : []}
        yokoziku={yokoziku}
        section="競合"
      />
    </Container>
  );
};

export default ProductAnalysisTable;
